<template>
  <div class="alert alert-info">
    <div class="alert-body">
      <slot />
    </div>
  </div>
</template>
